enum UserActionTypes {
  UPDATE_APP_USER_STATE = 'UPDATE_APP_USER_STATE',
  LOGOUT = 'LOGOUT',
}

export default UserActionTypes;
